import React, { useEffect, useRef, useState, useCallback } from "react";
import "./Strategy.css";
import { Col, Row } from "react-bootstrap";
import repeat from "../../assets/images/repeat.png";
import decision from "../../assets/images/decision1.png";
import open from "../../assets/images/add.png";
import close from "../../assets/images/close.png";
import { Dropdown } from "react-bootstrap";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import decisionImg1 from "../../assets/images/decision1.png";
import openPosition from "../../assets/images/add.png";
import closePosition from "../../assets/images/close.png";
import notification from "../../assets/images/notification.png";
import DecisionV1 from "./DecisionV1";
import updatePosition from "../../assets/images/update.png";
import tags from "../../assets/images/tags.png";
import { Link, useNavigate, useBlocker } from "react-router-dom";
import Flowchart from "./DrawChart/Flowchart";
import ChartLoader from "./DrawChart/ChartLoader";
import Spinner from "../common/Spinner";
import Toaster from "./Toaster/Toast";
import PositionItems from "../../components/strategy/OpenPosition/OpenDecisionItems";
import OpenDecision from "./OpenPosition/OpenDecision";
import { useMyContext } from "../../context/MyContext";
import DecisionItems from "./DecisionItems";
import decisionValues from "../decision.json";
import UpdatePosition from "./UpdatePosition/UpdatePosition";
import UpdateInputs from "./UpdatePosition/UpdateInputs";
import Tags from "./Tags/Tags";
import Repeat from "./Repeat";
import EndNode from "./EndNode/EndNode";
import ClosePosition from "./ExitPosition/ExitPosition";
import { LiaAngleDownSolid, LiaAngleLeftSolid } from "react-icons/lia";
import { BsArrowDown, BsArrowRight, BsPlay } from "react-icons/bs";
import { ReactFlowProvider } from "reactflow";
import Api from "../../api/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import QuestionModal from './Toaster/QuestionModal';
import { toast } from "react-toastify";

function Strategy(props) {
  const [cursorStyle, setCursorStyle] = useState("default");
  const [showModal, setShowModal] = useState(false);
  const [updateCharJson, setUpdateCharJson] = useState(false);
  const [nodes, setNodes] = useState([]);
  const [clickedNodePosition, setClickedNodePosition] = useState(null);
  const [parentNode, setParentNode] = useState({});
  const [selectedItem, setSelectedItem] = useState("");
  const [clickStr, setClickStr] = useState("start");
  const [buildJSON, setBuildJSON] = useState({});
  const [openPositions, setOpenPositions] = useState([]);
  const [iterateCnt, setIterateCnt] = useState(0);
  const [nodeNo, setNodeNo] = useState("");
  const [conditionCount, setConditionCount] = useState(0);
  const [entryCnt, setEntryCnt] = useState(0);
  const [closeCnt, setCloseCnt] = useState(0);
  const [repeatCnt, setRepeatCnt] = useState(0);
  const [tagsCnt, setTagsCnt] = useState(0);
  const [tagNames, setTagNames] = useState([]);
  const [updateCnt, setUpdateCnt] = useState(0);
  const [jsonKey, setJsonKey] = useState(0);
  const [isShow, setIsShow] = useState(false);
  const [id, setId] = useState(0);
  const navigate = useNavigate();
  const [strategyName, setStrategyName] = useState("Strategy_"+new Date().toISOString().split("T")[0]);
  const [sectionWidth, setSectionWidth] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [chartJson, setChartJson] = useState({
    value: [
      {
        id: "0",
        sourcePosition: "bottom",
        type: "selectorNode",
        data: {
          label: "Start",
          type: "start",
        },
        position: { x: window.innerWidth / 3 - 57, y: 0 },
      },
    ],
    edgeObj: [],
  });
  const [expandedL, setExpandedL] = useState(false);
  const [expandedR, setExpandedR] = useState(false);
  const [updateNodes, setUpdateNodes] = useState(false);
  const [isChart, setIsChart] = useState(true);
  const [curSelection, setCurSelection] = useState("");

  const [show, setShow] = useState(false);
  const target = useRef(null);
  const [isUpdateJson, setIsUpdateJson] = useState(false);
  const [flowchartFlow, setFlowchartFlow] = useState("V");
  const [isQuestionModalShow, setQuestionModalShow] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  let [decitionContent, setDecitionContent] = useState(
    decisionValues.decitionItems[0].key
  );

  let displayObj = {
    TEXT: "",
    x: window.innerWidth / 3 - 170,
    Y: 0,
  };
  const { decisionObject, setDecisionObject, strategyObject } = useMyContext();


  // Only block if isBlocked is true
  const blocker = useBlocker(
    useCallback(
      ({ currentLocation, nextLocation }) =>
        isUpdateJson && currentLocation.pathname !== nextLocation.pathname,
      [isUpdateJson]
    )
  );

  useEffect(() => {
    setQuestionModalShow(blocker.state === "blocked");
  }, [blocker.state]);

  const handleQuestionModalClose = (shouldProceed) => {
    setQuestionModalShow(false);
    if (shouldProceed) {
      blocker.proceed?.();
    } else {
      blocker.reset?.();
    }
  };

  useEffect(() => {
    const url = window.location.href;

    const endpoint = url.substring(url.lastIndexOf("=") + 1);

    if (url.includes('=') && endpoint) {
      setIsChart(false);
      //let res = Api.getchartofStrategy(endpoint)
      //editstrategyget(endpoint)
      Api.getchartofStrategy(endpoint)
        .then((res) => {
          const response = res; // assuming this is the API response
          const data = response.strategy.data;
          setStrategyName(response.strategy.strategy_name);
          setBuildJSON(JSON.parse(data));

          // let chartObj =
          //   flowchartFlow === "V"
          //     ? getNodes(JSON.parse(data))
          //     : getNodesHorizontal(JSON.parse(data));
          let chartObj = getNodes(JSON.parse(data));
          updateDefaultState(JSON.parse(data));

          if (chartObj.value.length > 0) {
            let updateVal = [...chartObj.value, ...chartJson.value];
            chartObj.value = updateVal;
            let updateObj = [
              {
                id: "0",
                source: "0",
                target: "1",
                type: "simplebezier",
                label: "",
              },
              ...chartObj.edgeObj,
            ];
            chartObj.edgeObj = updateObj;
          } else {
            chartObj = {
              value: [
                {
                  id: "0",
                  sourcePosition: "bottom",
                  type: "selectorNode",
                  data: {
                    label: "Start",
                    type: "start",
                  },
                  position: { x: window.innerWidth / 3 - 57, y: 0 },
                },
              ],
              edgeObj: []
            }
          }
          setChartJson(chartObj);
          setUpdateCharJson(!updateCharJson)
          setIsChart(true);
        })
        .catch((error) => {
          setIsChart(true);
          console.error("Request failed:", error);
        });

      // fetch(`${HOST}/strategy/${endpoint}`, {
      //   "Content-Type": "application/json",
      // })
      //   .then((response) => {
      //     // Check if the request was successful (status code 200)
      //     if (response.ok) {
      //       // Parse the response data as JSON
      //       return response.json();
      //     } else {
      //       throw new Error(
      //         `Request failed with status code ${response.status}`
      //       );
      //     }
      //   })
      //   .then((res) => {
      //     const data = res.strategy.data;
      //     setStrategyName(res.strategy.strategy_name);
      //     setBuildJSON(JSON.parse(data));
      //     let chartObj =
      //       flowchartFlow === "V"
      //         ? getNodes(JSON.parse(data))
      //         : getNodesHorizontal(JSON.parse(data));
      //     updateDefaultState(JSON.parse(data));
      //     if (chartObj.value.length > 0) {
      //       let updateVal = [...chartObj.value, ...chartJson.value];
      //       chartObj.value = updateVal;
      //       let updateObj = [
      //         {
      //           id: "0",
      //           source: "0",
      //           target: "1",
      //           type: "simplebezier",
      //           // animated: true,
      //           label: "",
      //         },
      //         ...chartObj.edgeObj,
      //       ];
      //       chartObj.edgeObj = updateObj;
      //       setChartJson(chartObj);
      //     }
      //     setIsChart(true);
      //   })
      //   .catch((error) => {
      //     setIsChart(true);
      //     console.error("Request failed:", error);
      //   });
    }
  }, []);

  const updateDefaultState = (json) => {
    setEntryCnt(0);
    setCloseCnt(0);
    setConditionCount(0);
    let positionArr = [];
    let maxConditionNum = 0;
    function traverseTree(node) {
      if (node == null) {
        return value;
      }
      if (node[Object.keys(node)[0]] != undefined) {
        const parts = node[Object.keys(node)[0]].ID.split(".");
        const nodeKey = Object.keys(node)[0];
        const nodeType = nodeKey.replace(/\d+/g, "");
        
        // Check for CONDITION nodes and find maximum condition number
        if (nodeType === "CONDITION") {
          const conditionNum = parseInt(nodeKey.replace(/\D/g, ""), 10);
          if (conditionNum > maxConditionNum) {
            maxConditionNum = conditionNum;
          }
        }
        
        if (parts?.join(".") === "1" || parts?.join(".") === "0") {
          if (nodeType == "ENTRY") {
            setEntryCnt((preCunt) => preCunt + 1);
            let currPosArr = {
              ID: node[Object.keys(node)[0]]["ID"],
              CLOSE: 0,
              POS: parseInt(parts?.join(".")),
              CLOSE_ID: [],
            };
            positionArr.push(currPosArr);
          }
        } else {
          parts?.pop(); // Remove the last element
          const outputString = parts?.join(".");
          if (outputString != "") {
            let intVal = parseInt(nodeKey.replace(/\D/g, ""), 10);
            if (nodeType == "ENTRY") {
              setEntryCnt((preCunt) => preCunt + 1);
              // positionArr.push(intVal)
              let currPosArr = {
                ID: node[Object.keys(node)[0]]["ID"],
                CLOSE: 0,
                POS: parseInt(intVal),
                CLOSE_ID: [],
              };

              positionArr.push(currPosArr);
              // props.setOpenPositions([...props.openPositions, currPosArr]);
            } else if (nodeType == "EXIT") {
              setCloseCnt((preCnt) => preCnt + 1);
              // let posArr = node[Object.keys(node)[0]][Object.keys(node)[0]]
              // posArr?.map(position => {
              positionArr.map((item) => {
                node[node["KEY"]]["EXIT_POS"].map((pos) => {
                  if (parseInt(pos.replace(/\D/g, ""), 10) === item.POS) {
                    item.CLOSE = 1;
                    item.CLOSE_ID = [
                      ...item.CLOSE_ID,
                      node[Object.keys(node)[0]]["ID"],
                    ];
                  }
                });
              });
              // if (positionArr.includes(parseInt(position.replace(/\D/g, ''), 10)) !== -1) {
              // positionArr.splice(positionArr.indexOf(parseInt(position.replace(/\D/g, ''), 10)), 1)
              // }

              // });
            } else if (nodeType == "UPDATE") {
              setUpdateCnt((preCnt) => preCnt + 1);
            }
          }
        }
      }
      if (node[Object.keys(node)[0]]?.YES != undefined)
        traverseTree(node[Object.keys(node)[0]]?.YES);
      if (node[Object.keys(node)[0]]?.NO != undefined)
        traverseTree(node[Object.keys(node)[0]]?.NO);
    }

    traverseTree(json);
    setConditionCount(maxConditionNum);
    setOpenPositions(positionArr);
  };

  useEffect(() => {
    let chartObj = null;
    chartObj = getNodes(buildJSON);
    const edgeStyles = {
      stroke: '#4DD5B8',
      strokeWidth: 1,
      strokeDasharray: '4',
    };
    if (chartObj.value.length > 0) {
      // let updateVal = [...chartObj.value, ...chartJson.value];
      let updateVal = [...chartObj.value, {
        id: "0",
        sourcePosition: "bottom",
        type: "selectorNode",
        data: {
          label: "Start",
          type: "start",
        },
        position: { x: window.innerWidth / 3 - 57, y: 0 },
      }];
      chartObj.value = updateVal;

      let updateObj = [
        {
          id: "0",
          source: "0",
          target: "1",
          type: "simplebezier",
          // animated: true,
          label: "",
          style: edgeStyles,
        },
        ...chartObj.edgeObj,
      ];
      chartObj.edgeObj = updateObj;
    } else {
      chartObj = {
        value: [
          {
            id: "0",
            sourcePosition: "bottom",
            type: "selectorNode",
            data: {
              label: "Start",
              type: "start",
            },
            position: { x: window.innerWidth / 3 - 57, y: 0 },
          },
        ],
        edgeObj: []
      }
    }
    setChartJson(chartObj);
    setUpdateCharJson(!updateCharJson)
  }, [buildJSON, isUpdateJson]);

  // useEffect(() => {
  //   // let chartObj =
  //   //   flowchartFlow === "V"
  //   //     ? getNodes(buildJSON)
  //   //     : getNodesHorizontal(buildJSON);
  //   let chartObj = getNodes(JSON.parse(data));

  //   if (chartObj.value.length > 0) {
  //     let updateVal = [
  //       ...chartObj.value,
  //       {
  //         id: "0",
  //         sourcePosition: "bottom",
  //         type: "selectorNode",
  //         data: {
  //           label: "Start",
  //           type: "start",
  //         },
  //         position: {
  //           x: flowchartFlow === "V" ? window.innerWidth / 3 - 57 : 0,
  //           y: flowchartFlow === "H" ? window.innerHeight / 3 - 57 : 0,
  //         },
  //       },
  //     ];
  //     chartObj.value = updateVal;
  //     const edgeStyles = {
  //       stroke: '#4DD5B8',
  //       strokeWidth: 1,
  //       strokeDasharray: '4',
  //     };
  //     let updateObj = [
  //       {
  //         id: "0",
  //         source: "0",
  //         target: "1",
  //         type: "simplebezier",
  //         // animated: true,
  //         label: "",
  //         style: edgeStyles,
  //       },
  //       ...chartObj.edgeObj,
  //     ];
  //     chartObj.edgeObj = updateObj;
  //     setChartJson(chartObj);
  //   }
  // }, [showModal]);

  var obj = {};
  const DisplayStrategy = (props) => {
    const [upadteJson, setUpadteJson] = useState(0);
    var image = decision;
    let lineStr = "";
    const pathStyle = {
      fill: "none",
      stroke: "lightblue",
      strokeWidth: 0.5,
    };
    var xPos = window.innerWidth / 3 - 60;
    obj[1] = xPos;
    function manageAxis(json) {
      var value = [];
      var isUpdate = false;
      function traverseTree(node) {
        if (node == null) {
          return value;
        }
        if (
          Object.keys(node).length > 0 &&
          node[Object.keys(node)[0]].ID != "1"
        ) {
          let matchingIds = [];
          let preId = node[Object.keys(node)[0]].ID.split(".");
          let nodeInd = node[Object.keys(node)[0]].ID;
          preId.pop();
          preId = preId.join(".");
          let isCollide = false;
          let [outerAxis, preNode] = getAxis(buildJSON, preId);
          let compareVal = parseInt(obj[preId]);
          if (nodeInd.split(".").at(-1) == "1") {
            compareVal = parseInt(obj[preId]) - 75;
          } else if (nodeInd.split(".").at(-1) == "2") {
            compareVal = parseInt(obj[preId]) + 75;
          }
          for (const objectId in obj) {
            if (
              obj[objectId] == compareVal &&
              nodeInd.split(".").length == objectId.split(".").length &&
              nodeInd != "1" &&
              nodeInd != objectId
            ) {
              matchingIds.push(objectId);
              isCollide = true;
            }
          }
          if (isCollide && preId != "") {
            obj[preId] = parseInt(obj[preId]) + 150;
            let nextLId = preId + ".1";
            let nextRId = preId + ".2";
            obj[nextLId] = parseInt(obj[preId]) - 75;
            obj[nextRId] = parseInt(obj[preId]) + 75;
            // manageAxis(buildJSON);
          } else if (preId != "") {
            if (nodeInd.split(".").at(-1) == "1") {
              if (
                Object?.keys(preNode)[0].replace(/\d+/g, "") == "ENTRY" ||
                Object?.keys(preNode)[0].replace(/\d+/g, "") == "EXIT" ||
                Object?.keys(preNode)[0].replace(/\d+/g, "") == "REPEAT"
              ) {
                obj[nodeInd] = parseInt(obj[preId]);
              } else {
                obj[nodeInd] = parseInt(obj[preId]) - 75;
                let rightId = preId + ".2";
                obj[rightId] = parseInt(obj[preId]) + 75;
              }
            } else if (nodeInd.split(".").at(-1) == "2") {
              if (
                Object?.keys(preNode)[0].replace(/\d+/g, "") == "ENTRY" ||
                Object?.keys(preNode)[0].replace(/\d+/g, "") == "EXIT" ||
                Object?.keys(preNode)[0].replace(/\d+/g, "") == "REPEAT"
              ) {
                obj[nodeInd] = parseInt(obj[preId]);
              } else {
                if (obj[nodeInd] == "undefined")
                  obj[nodeInd] = parseInt(obj[preId]) - 75;
              }
            } else {
              obj[nodeInd] = parseInt(obj[preId]) + 75;
            }
          } else {
            obj[nodeInd] = preId != "" ? parseInt(obj[preId]) : xPos;
          }
          isUpdate = true;
        }

        if (
          node[Object.keys(node)[0]]?.YES != undefined &&
          Object.keys(node[Object.keys(node)[0]]?.YES).length > 0
        ) {
          traverseTree(node[Object.keys(node)[0]]?.YES);
        }
        if (
          node[Object.keys(node)[0]]?.NO != undefined &&
          Object.keys(node[Object.keys(node)[0]]?.NO).length > 0
        ) {
          traverseTree(node[Object.keys(node)[0]]?.NO);
        }
      }
      traverseTree(json);
      return obj;
    }
    let pos = manageAxis(buildJSON);
    useEffect(() => {
      props.setData(buildJSON);
    }, [upadteJson]);

    const handleStrategySelect = (eventKey, str, json) => {
      setJsonKey(json.ID);
      setSelectedItem(eventKey);
      handleOpenModal();
      handleFlowchart(str);
    };

    function getAxis(obj, id) {
      var update = 0;
      var value = window.innerWidth / 3 - 60;
      var curNode = "";
      function traverseTree(node) {
        if (node == null) {
          return value;
        }
        let incomingId = node[Object?.keys(node)[0]]?.ID;
        if (incomingId == id && !update) {
          update = 1;
          value = node[Object?.keys(node)[0]]?.X;
          curNode = node;
          return node[Object?.keys(node)[0]]?.X;
        } else if (!update) {
          traverseTree(node[Object.keys(node)[0]]?.YES, id);
          if (
            node[Object.keys(node)[0]]?.NO != undefined &&
            Object.keys(node[Object.keys(node)[0]]?.NO).length > 0
          ) {
            traverseTree(node[Object.keys(node)[0]]?.NO, id);
          }
        }
      }
      traverseTree(obj, id);
      return [value, curNode];
    }

    const parts = props.data?.ID.split(".");
    parts?.pop(); // Remove the last element
    const outputString = parts?.join(".");
    let [outerAxis, node] = getAxis(buildJSON, outputString);
    let lPos = xPos;
    if (props.data != undefined && props.data["END"] != "END") {
      displayObj.Y = 0;
      lineStr = "M18, 15 V8 V18";
      displayObj.X = outerAxis;
      props.data?.ID.split(".").map((index, key) => {
        displayObj.Y += 65;
        if (
          index == "1" &&
          props.obj?.YES &&
          Object.keys(props.obj?.YES).length > 0
        ) {
          if (
            Object?.keys(node)[0].replace(/\d+/g, "") == "ENTRY" ||
            Object?.keys(node)[0].replace(/\d+/g, "") == "EXIT" ||
            Object?.keys(node)[0].replace(/\d+/g, "") == "REPEAT"
          ) {
            lineStr = "M0, 15 V8 V18";
            displayObj.X = outerAxis;
            lPos = obj[outputString] + 50;
          } else {
            let xLen = (obj[outputString] - obj[props.data?.ID]) / 2;
            displayObj.X = outerAxis - 50;
            lineStr = `M15,25 V13 H${xLen} V8`;
            lPos = obj[outputString] - 80;
            // if (props.data?.ID == '1.1') {
            //     lineStr = `M15,25 V13 H65 V8`;
            // }
          }
        } else if (
          index == "2" &&
          props.obj?.NO &&
          Object.keys(props.obj?.NO).length > 0
        ) {
          if (
            Object?.keys(node)[0].replace(/\d+/g, "") == "ENTRY" ||
            Object?.keys(node)[0].replace(/\d+/g, "") == "EXIT" ||
            Object?.keys(node)[0].replace(/\d+/g, "") == "REPEAT"
          ) {
            lineStr = "M0, 15 V8 V18";
            displayObj.X = outerAxis;
            lPos = obj[outputString];
          } else {
            let xLen = (obj[props.data?.ID] - 10 - obj[outputString] - 50) / 2;
            displayObj.X = outerAxis - 50;
            lineStr = `M0,5 V13 H${xLen} V20`;
            displayObj.X = outerAxis + 100;
            lPos = obj[outputString] + 70;
          }
        } else {
          displayObj.X = outerAxis;
        }
      });
      if (Object.keys(obj).length > 0)
        setSectionWidth(Object.values(obj)[Object.keys(obj).length - 1]);
      props.data.X = obj[props.data?.ID];
      props.data.Y = displayObj.Y;
      let nodeStr = "";
      nodeStr =
        props.data.TMP_ID != "REPEAT"
          ? Object.keys(props.data["CONTENT"])
            .map((key) => props.data["CONTENT"][key])
            .join(" ")
          : props.data["CONTENT"];
      displayObj.TEXT = nodeStr;
      if (props.data.TMP_ID != undefined && props.data.TMP_ID == "OPEN") {
        image = open;
      } else if (
        props.data.TMP_ID != undefined &&
        props.data.TMP_ID == "CLOSE"
      ) {
        image = close;
      } else if (props.data.TMP_ID == "REPEAT") {
        if (displayObj.TEXT == "") {
          displayObj.TEXT = "REPEAT";
        }
        image = repeat;
      }
    }

    const handleFlowchart = (val) => {
      setClickStr(val);
      if ((val = "NO")) {
        let nodeKey = nodeNo + "." + val;
        setNodeNo(nodeKey);
      }
      setShowModal(true);
    };

    const TooltipOnHover = (props) => {
      const tooltip = <Tooltip id="tooltip-example">{props.text}</Tooltip>;
      return (
        <OverlayTrigger placement="top" overlay={tooltip}>
          <span>
            <img src={image} height={35} className="node-img" />
            <p
              className={
                props.tmp_id == "CLOSE"
                  ? "text-danger pt-3 node-text"
                  : "pt-3 text-muted node-text"
              }
            >
              {props.text}
            </p>
          </span>
        </OverlayTrigger>
      );
    };

    // function findAndUpdatePos(obj, id, X, Y) {
    //   var update = 0;
    //   function traverseTree(node) {
    //     if (node == null) {
    //       return 0;
    //     }
    //     let incomingId = node[Object?.keys(node)[0]]?.ID;
    //     if (incomingId == id && !update) {
    //       update = 1;
    //       node[Object.keys(node)[0]].X = X;
    //       node[Object.keys(node)[0]].Y = Y;
    //       setUpadteJson(1);
    //       return node;
    //     } else {
    //       traverseTree(node[Object.keys(node)[0]]?.YES, id);
    //       if (
    //         node[Object.keys(node)[0]]?.NO != undefined &&
    //         Object.keys(node[Object.keys(node)[0]]?.NO).length > 0
    //       ) {
    //         traverseTree(node[Object.keys(node)[0]]?.NO, id);
    //       }
    //     }
    //   }
    //   let nodes = traverseTree(obj, id);
    //   return nodes;
    // }

    // const handleDragStart = (e, id) => {
    //     findAndUpdatePos(buildJSON, id,  e.clientX, e.clientY);
    //     props.setData(buildJSON);
    // }

    // const printDrag = (e) => {
    // }

    return (
      displayObj["TEXT"] != "" &&
      props.data != undefined && (
        <div>
          <div
            className="node"
            style={{ top: props.data.Y, left: props.data.X }}
            draggable
          >
            {/* onDragOver={(e) =>handleDragStart(e, props.data?.ID)}
                        onDrop={printDrag} */}
            {/* onDragOver={handleDragStart} */}
            <TooltipOnHover
              text={displayObj["TEXT"]}
              tmp_id={props.data.TMP_ID}
            />
            <div className="node-options">
              {props.data.TMP_ID != undefined &&
                props.data.TMP_ID != "CLOSE" &&
                props.data.TMP_ID != "REPEAT" && (
                  <ToggleButtonGroup
                    type="radio"
                    name="options"
                    value={selectedOption}
                  >
                    <ToggleButton
                      variant={
                        selectedOption === "yes"
                          ? "outline-primary"
                          : "outline-secondary"
                      }
                      value="yes"
                      className={selectedOption === "no" ? "active" : ""}
                    // onClick={() => handleFlowchart('YES')}
                    >
                      <Dropdown
                        className="btn-sm"
                        onSelect={(e) =>
                          handleStrategySelect(e, "YES", props.data)
                        }
                      >
                        <Dropdown.Toggle variant="primary" id="dropdown-basic">
                          Y
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="border-0 shadow-none">
                          <Dropdown.Item href="#" eventKey="decision">
                            {/* {activeTab == "decision" && <img src={decisionImg} width='18' />} */}
                            {<img src={decisionImg1} width="18" />} Decision
                          </Dropdown.Item>
                          <Dropdown.Item href="#" eventKey="open-position">
                            <img src={openPosition} width="18" /> Open Position
                          </Dropdown.Item>
                          <Dropdown.Item href="#" eventKey="close-position">
                            <img src={closePosition} width="18" /> Close
                            Position
                          </Dropdown.Item>
                          <Dropdown.Item href="#" eventKey="exist-position">
                            <img src={updatePosition} width="18" /> Update Exist
                            Positions
                          </Dropdown.Item>
                          <Dropdown.Item href="#" eventKey="notification">
                            <img src={notification} width="18" /> Notification
                          </Dropdown.Item>
                          <Dropdown.Item href="#" eventKey="tags">
                            <img src={tags} width="18" /> Tags
                          </Dropdown.Item>
                          <Dropdown.Item href="#" eventKey="repeat">
                            <img src={tags} width="18" /> Repeat
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </ToggleButton>
                    {props.data?.NO != undefined && (
                      <ToggleButton
                        variant={
                          selectedOption === "yes"
                            ? "outline-primary"
                            : "outline-secondary"
                        }
                        value="no"
                        className={selectedOption === "no" ? "active" : ""}
                      // onClick={() => handleFlowchart('NO')}
                      // onClick={() => handleNoNode('NO')}
                      >
                        <Dropdown
                          className=" btn-sm"
                          onSelect={(e) =>
                            handleStrategySelect(e, "NO", props.data)
                          }
                        >
                          <Dropdown.Toggle
                            variant="primary"
                            id="dropdown-basic"
                          >
                            N
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="border-0 shadow-none">
                            <Dropdown.Item href="#" eventKey="decision">
                              {/* {activeTab == "decision" && <img src={decisionImg} width='18' />} */}
                              {<img src={decisionImg1} width="18" />} Decision
                            </Dropdown.Item>
                            <Dropdown.Item href="#" eventKey="open-position">
                              <img src={openPosition} width="18" /> Open
                              Position
                            </Dropdown.Item>
                            <Dropdown.Item href="#" eventKey="close-position">
                              <img src={closePosition} width="18" /> Close
                              Position
                            </Dropdown.Item>
                            <Dropdown.Item href="#" eventKey="exist-position">
                              <img src={updatePosition} width="18" /> Update
                              Exist Positions
                            </Dropdown.Item>
                            <Dropdown.Item href="#" eventKey="notification">
                              <img src={notification} width="18" /> Notification
                            </Dropdown.Item>
                            <Dropdown.Item href="#" eventKey="tags">
                              <img src={tags} width="18" /> Tags
                            </Dropdown.Item>
                            <Dropdown.Item href="#" eventKey="repeat">
                              <img src={tags} width="18" /> Repeat
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </ToggleButton>
                    )}
                  </ToggleButtonGroup>
                )}
            </div>
          </div>
          <svg
            viewBox="0 0 100 100"
            style={{
              width: "300",
              height: "300",
              position: "absolute",
              left: lPos,
              top: displayObj.Y - 50,
            }}
          >
            <path d={lineStr} style={pathStyle} strokeDasharray="2 1" />
          </svg>
          {/* <CurvedLines width={25} /> */}
          {props.data != null &&
            props.data != undefined &&
            Object.keys(props.data.YES).length != 0 && (
              <DisplayStrategy
                data={props.data.YES[Object.keys(props.data.YES)[0]]}
                nodeType="YES"
                obj={props.data}
                setData={setBuildJSON}
              />
            )}
          {props.data != null &&
            props.data.NO != undefined &&
            Object.keys(props.data?.NO)?.length != 0 && (
              <DisplayStrategy
                data={props.data.NO[Object.keys(props.data.NO)[0]]}
                nodeType="NO"
                obj={props.data}
                setData={setBuildJSON}
              />
            )}
        </div>
      )
    );
  };


  const saveJson = async () => {
    setIsSaving(true);
    try {
      const postData = {
        user_id: JSON.parse(localStorage.getItem("user_details")).user_id,
        email: JSON.parse(localStorage.getItem("user_details")).email,
        subscription_id: 0,
        data: buildJSON,
        strategy_name: strategyName,
        status: 0,
      };

      const strategyId = window.location.search.split("=")[1] || null; // Get strategy ID from URL if exists

      const response = await Api.saveStrategy(postData, strategyId);
      if (response) {
        toast.info(response.message);
        setIsUpdateJson(false); // Reset the update flag after successful save
        navigate("/strategies");
      }
    } catch (error) {
      console.error("Error saving strategy:", error);
      toast.error("Failed to save strategy");
    } finally {
      setIsSaving(false);
    }
  };

  const navigateToStrategy = () => {
    navigate("/strategies");
  };

  const [selectedOption, setSelectedOption] = useState("");

  const handleOpenModal = () => {
    setShowModal(true);
    setClickStr("start");
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  var value = [];
  var edgeObj = [];
  let X = 0;
  let Y = 0;

  function getNodes(obj) {
    value = [];
    edgeObj = [];
    const edgeStyles = {
      stroke: '#4DD5B8',
      strokeWidth: 1,
      strokeDasharray: '4',
    };

    function traverseTree(node) {
      if (node == null) {
        return value;
      }

      if (node[Object.keys(node)[0]] != undefined) {
        let nodeStr =
          node[Object.keys(node)[0]].TMP_ID !== "REPEAT"
            ? Object.keys(node[Object.keys(node)[0]]["CONTENT"])
              .map((key) => node[Object.keys(node)[0]]["CONTENT"][key])
              .join(" ")
            : node[Object.keys(node)[0]]["CONTENT"];
        const parts = node[Object.keys(node)[0]].ID.split(".");
        if (parts?.join(".") === "1" || parts?.join(".") === "0") {
          Y = 75;
          X = window.innerWidth / 3 - 50;
          updateAxis(buildJSON, node[Object.keys(node)[0]].ID, X, Y);
          // if (Object.keys(node)[0].replace(/\d+/g, '') == "ENTRY") {
          //     setEntryCnt(preCunt => preCunt + 1)
          // }
        } else {
          parts?.pop(); // Remove the last element
          const outputString = parts?.join(".");
          if (outputString != "" && node[Object.keys(node)[0]].X == undefined) {
            let [axisX, axisY, curNode] = getAxis(buildJSON, outputString);
            if (axisX === 0 || axisX === undefined) {
              X = 0;
            } else if (
              clickStr == "YES" &&
              Object.keys(curNode)[0].replace(/\d+/g, "") == "CONDITION"
            ) {
              X = axisX - 100;
            } else if (
              clickStr == "NO" &&
              Object.keys(curNode)[0].replace(/\d+/g, "") == "CONDITION"
            ) {
              X = axisX + 100;
            } else {
              X = axisX;
            }
            Y = axisY === 0 || axisY === undefined ? 0 : axisY + 100;

            // if (Object.keys(node)[0].replace(/\d+/g, '') == "ENTRY") {
            //     setEntryCnt(preCunt => preCunt + 1);
            //     console.log(entryCnt)
            // } else if (Object.keys(node)[0].replace(/\d+/g, '') == "EXIT") {
            //     setCloseCnt(preCnt => preCnt + 1)
            // }
            updateAxis(buildJSON, node[Object.keys(node)[0]].ID, X, Y);
          }
        }

        let newObj = {
          id: node[Object.keys(node)[0]]?.ID,
          sourcePosition: "bottom",
          targetPosition: "top",
          type: "selectorNode",
          data: {
            label: nodeStr.trim(),
            type: Object.keys(node)[0],
          },
          position: {
            x: node[Object.keys(node)[0]].X ? node[Object.keys(node)[0]].X : X,
            y: node[Object.keys(node)[0]].Y ? node[Object.keys(node)[0]].Y : Y,
          },
        };
        let isPresent = value.some((obj) => obj.id === newObj.id);
        if (!isPresent) {
          value.push(newObj);
        }
        // value.push(newObj);

        if (
          Object.keys(node[Object.keys(node)[0]]["YES"]).length == 0 &&
          Object.keys(node)[0].replace(/\d+/g, "") !== "REPEAT" &&
          Object.keys(node)[0].replace(/\d+/g, "") !== "END"
        ) {
          let obj_y = {
            id: node[Object.keys(node)[0]]?.ID + ".1",
            sourcePosition: "top",
            type: "selectorNode",
            // sourcePosition: 'bottom',
            connectable: false,
            data: {
              label: "Y",
              type: Object.keys(node)[0],
              category: "sub",
            },
            position: {
              x:
                Object.keys(node)[0].replace(/\d+/g, "") !== "CONDITION"
                  ? node[Object.keys(node)[0]].X - 25
                  : node[Object.keys(node)[0]].X
                    ? node[Object.keys(node)[0]].X - 50
                    : X - 50,
              y: node[Object.keys(node)[0]].Y
                ? node[Object.keys(node)[0]].Y + 100
                : Y + 100,
            },
          };
          // value.push(obj_y);
          let isPresent = value.some((obj) => obj.id === obj_y.id);
          if (!isPresent) {
            value.push(obj_y);
          }
          // 'edge'

          let edgeObj_y = {
            id: node[Object.keys(node)[0]]?.ID,
            source: node[Object.keys(node)[0]]?.ID,
            target: node[Object.keys(node)[0]]?.ID + ".1",
            type: "simplebezier",
            animated: true,
            label: Object.keys(node)[0].replace(/\d+/g, "") === "CONDITION" ? "Yes" : "",
          };
          edgeObj.push(edgeObj_y);
        }

        if (
          Object.keys(node[Object.keys(node)[0]]["NO"]).length == 0 &&
          Object.keys(node)[0].replace(/\d+/g, "") === "CONDITION" &&
          Object.keys(node)[0].replace(/\d+/g, "") !== "REPEAT" &&
          Object.keys(node)[0].replace(/\d+/g, "") !== "END"
        ) {
          let obj_n = {
            id: node[Object.keys(node)[0]]?.ID + ".2",
            targetPosition: "top",
            type: "selectorNode",
            data: {
              label: "N",
              type: Object.keys(node)[0],
              category: "sub",
            },
            position: {
              x: node[Object.keys(node)[0]].X
                ? node[Object.keys(node)[0]].X + 100
                : X + 100,
              y: node[Object.keys(node)[0]].Y
                ? node[Object.keys(node)[0]].Y + 100
                : Y + 100,
            },
          };

          let edgeObj_n = {
            id: node[Object.keys(node)[0]]?.ID,
            source: node[Object.keys(node)[0]]?.ID,
            target: node[Object.keys(node)[0]]?.ID + ".2",
            type: "simplebezier",
            animated: true,
            label: "No",

          };
          edgeObj.push(edgeObj_n);
          // value.push(obj_n);
          let isPresent = value.some((obj) => obj.id === obj_n.id);
          if (!isPresent) {
            value.push(obj_n);
          }
        }

        let newEdge1 = {};
        let newEdge2 = {};
        if (
          node[Object.keys(node)[0]]?.YES &&
          Object.keys(node[Object.keys(node)[0]]?.YES).length > 0 &&
          node[Object.keys(node)[0]]?.ID != "0"
        ) {
          newEdge1 = {
            id: node[Object.keys(node)[0]]?.ID,
            source: node[Object.keys(node)[0]]?.ID,
            target: node[Object.keys(node)[0]]?.ID + ".1",
            type: "simplebezier",
            label: Object.keys(node)[0].replace(/\d+/g, "") === "CONDITION" ? "Yes" : "",
            style: edgeStyles,
          };
        }
        if (
          node[Object.keys(node)[0]]?.NO &&
          Object.keys(node[Object.keys(node)[0]]?.NO).length > 0 &&
          node[Object.keys(node)[0]]?.ID != "0"
        ) {
          newEdge2 = {
            id: node[Object.keys(node)[0]]?.ID,
            source: node[Object.keys(node)[0]]?.ID,
            target: node[Object.keys(node)[0]]?.ID + ".2",
            type: "simplebezier",
            label: "No",
            style: edgeStyles,
          };
        }

        if (newEdge1 && Object.keys(newEdge1).length > 0)
          edgeObj.push(newEdge1);
        if (newEdge2 && Object.keys(newEdge2).length > 0)
          edgeObj.push(newEdge2);
      }
      if (node[Object.keys(node)[0]]?.YES != undefined)
        traverseTree(node[Object.keys(node)[0]]?.YES);
      if (node[Object.keys(node)[0]]?.NO != undefined)
        traverseTree(node[Object.keys(node)[0]]?.NO);
    }
    traverseTree(obj);
    return { value, edgeObj };
  }

  function getNodesHorizontal(obj) {
    value = [];
    edgeObj = [];
    function traverseTree(node) {
      if (node == null) {
        return value;
      }
      if (node[Object.keys(node)[0]] != undefined) {
        let nodeStr =
          node[Object.keys(node)[0]].TMP_ID !== "REPEAT"
            ? Object.keys(node[Object.keys(node)[0]]["CONTENT"])
              .map((key) => node[Object.keys(node)[0]]["CONTENT"][key])
              .join(" ")
            : node[Object.keys(node)[0]]["CONTENT"];
        const parts = node[Object.keys(node)[0]].ID.split(".");
        if (parts?.join(".") === "1" || parts?.join(".") === "0") {
          Y = window.innerHeight / 2 - 50;
          X = 75;
          updateAxis(buildJSON, node[Object.keys(node)[0]].ID, X, Y);
          // if (Object.keys(node)[0].replace(/\d+/g, '') == "ENTRY") {
          //     setEntryCnt(preCunt => preCunt + 1)
          // }
        } else {
          parts?.pop(); // Remove the last element
          const outputString = parts?.join(".");
          if (outputString != "" && node[Object.keys(node)[0]].X == undefined) {
            let [axisX, axisY, curNode] = getAxis(buildJSON, outputString);
            if (axisX === 0 || axisX === undefined) {
              X = 0;
            } else if (
              clickStr == "YES" &&
              Object.keys(curNode)[0].replace(/\d+/g, "") == "CONDITION"
            ) {
              Y = axisY - 50;
            } else if (
              clickStr == "NO" &&
              Object.keys(curNode)[0].replace(/\d+/g, "") == "CONDITION"
            ) {
              Y = axisY + 50;
            } else {
              Y = axisY;
            }
            X = axisX === 0 || axisX === undefined ? 0 : axisX + 50;

            // if (Object.keys(node)[0].replace(/\d+/g, '') == "ENTRY") {
            //     setEntryCnt(preCunt => preCunt + 1);
            // } else if (Object.keys(node)[0].replace(/\d+/g, '') == "EXIT") {
            //     setCloseCnt(preCnt => preCnt + 1)
            // }
            updateAxis(buildJSON, node[Object.keys(node)[0]].ID, X, Y);
          }
        }

        let newObj = {
          id: node[Object.keys(node)[0]]?.ID,
          sourcePosition: "left",
          targetPosition: "right",
          type: "selectorNode",
          data: {
            label: nodeStr.trim(),
            type: Object.keys(node)[0],
          },
          position: {
            x: node[Object.keys(node)[0]].X ? node[Object.keys(node)[0]].X : X,
            y: node[Object.keys(node)[0]].Y ? node[Object.keys(node)[0]].Y : Y,
          },
        };
        let isPresent = value.some((obj) => obj.id === newObj.id);
        if (!isPresent) {
          value.push(newObj);
        }
        // value.push(newObj);

        if (
          Object.keys(node[Object.keys(node)[0]]["YES"]).length == 0 &&
          Object.keys(node)[0].replace(/\d+/g, "") !== "REPEAT" &&
          Object.keys(node)[0].replace(/\d+/g, "") !== "END"
        ) {
          let obj_y = {
            id: node[Object.keys(node)[0]]?.ID + ".1",
            targetPosition: "top",
            type: "selectorNode",
            // sourcePosition: 'bottom',
            connectable: false,
            data: {
              label: "Y",
              type: Object.keys(node)[0],
              category: "sub",
            },
            position: {
              x:
                Object.keys(node)[0].replace(/\d+/g, "") !== "CONDITION"
                  ? node[Object.keys(node)[0]].X - 25
                  : node[Object.keys(node)[0]].X
                    ? node[Object.keys(node)[0]].X - 50
                    : X - 50,
              y: node[Object.keys(node)[0]].Y
                ? node[Object.keys(node)[0]].Y + 50
                : Y + 50,
            },
          };
          // value.push(obj_y);
          let isPresent = value.some((obj) => obj.id === obj_y.id);
          if (!isPresent) {
            value.push(obj_y);
          }
          // edge
          let edgeObj_y = {
            id: node[Object.keys(node)[0]]?.ID,
            source: node[Object.keys(node)[0]]?.ID,
            target: node[Object.keys(node)[0]]?.ID + ".1",
            type: "simplebezier",
            animated: true,
            label: Object.keys(node)[0].replace(/\d+/g, "") === "CONDITION" ? "Yes" : "",
          };
          edgeObj.push(edgeObj_y);
        }

        if (
          Object.keys(node[Object.keys(node)[0]]["NO"]).length == 0 &&
          Object.keys(node)[0].replace(/\d+/g, "") === "CONDITION" &&
          Object.keys(node)[0].replace(/\d+/g, "") !== "REPEAT" &&
          Object.keys(node)[0].replace(/\d+/g, "") !== "END"
        ) {
          let obj_n = {
            id: node[Object.keys(node)[0]]?.ID + ".2",
            targetPosition: "top",
            type: "selectorNode",
            data: {
              label: "N",
              type: Object.keys(node)[0],
              category: "sub",
            },
            position: {
              x: node[Object.keys(node)[0]].X
                ? node[Object.keys(node)[0]].X + 100
                : X + 50,
              y: node[Object.keys(node)[0]].Y
                ? node[Object.keys(node)[0]].Y + 50
                : Y + 50,
            },
          };

          let edgeObj_n = {
            id: node[Object.keys(node)[0]]?.ID,
            source: node[Object.keys(node)[0]]?.ID,
            target: node[Object.keys(node)[0]]?.ID + ".2",
            type: "simplebezier",
            animated: true,
            label: "No",
          };
          edgeObj.push(edgeObj_n);
          // value.push(obj_n);
          let isPresent = value.some((obj) => obj.id === obj_n.id);
          if (!isPresent) {
            value.push(obj_n);
          }
        }

        let newEdge1 = {};
        let newEdge2 = {};
        if (
          node[Object.keys(node)[0]]?.YES &&
          Object.keys(node[Object.keys(node)[0]]?.YES).length > 0 &&
          node[Object.keys(node)[0]]?.ID != "0"
        ) {
          newEdge1 = {
            id: node[Object.keys(node)[0]]?.ID,
            source: node[Object.keys(node)[0]]?.ID,
            target: node[Object.keys(node)[0]]?.ID + ".1",
            type: "simplebezier",
            label: "Yes",
          };
        }
        if (
          node[Object.keys(node)[0]]?.NO &&
          Object.keys(node[Object.keys(node)[0]]?.NO).length > 0 &&
          node[Object.keys(node)[0]]?.ID != "0"
        ) {
          newEdge2 = {
            id: node[Object.keys(node)[0]]?.ID,
            source: node[Object.keys(node)[0]]?.ID,
            target: node[Object.keys(node)[0]]?.ID + ".2",
            type: "simplebezier",
            label: "No",
          };
        }

        if (newEdge1 && Object.keys(newEdge1).length > 0)
          edgeObj.push(newEdge1);
        if (newEdge2 && Object.keys(newEdge2).length > 0)
          edgeObj.push(newEdge2);
      }
      if (node[Object.keys(node)[0]]?.YES != undefined)
        traverseTree(node[Object.keys(node)[0]]?.YES);
      if (node[Object.keys(node)[0]]?.NO != undefined)
        traverseTree(node[Object.keys(node)[0]]?.NO);
    }
    traverseTree(obj);
    return { value, edgeObj };
  }

  function updateAxis(obj, id, x, y) {
    function traverseTree(node) {
      if (node == null) {
        return "1";
      }
      let incomingId = node[Object?.keys(node)[0]]?.ID;
      if (incomingId == id) {
        node[Object?.keys(node)[0]].X = x;
        node[Object?.keys(node)[0]].Y = y;
        setBuildJSON(obj);
        return node[Object?.keys(node)[0]];
      } else {
        traverseTree(node[Object.keys(node)[0]]?.YES);
        if (
          node[Object.keys(node)[0]]?.NO != undefined &&
          Object.keys(node[Object.keys(node)[0]]?.NO).length > 0
        ) {
          traverseTree(node[Object.keys(node)[0]]?.NO);
        }
      }
    }
    traverseTree(obj, id);
  }

  function getAxis(obj, id) {
    var update = 0;
    var valueX = window.innerWidth / 3 - 60;
    var valueY = 0;
    var curNode = "";
    function traverseTree(node) {
      if (node == null) {
        return value;
      }
      let incomingId = node[Object?.keys(node)[0]]?.ID;
      if (incomingId == id && !update) {
        update = 1;
        valueX = node[Object?.keys(node)[0]]?.X;
        valueY = node[Object?.keys(node)[0]]?.Y;
        curNode = node;
        return node[Object?.keys(node)[0]]?.X;
      } else if (!update) {
        traverseTree(node[Object.keys(node)[0]]?.YES, id);
        if (
          node[Object.keys(node)[0]]?.NO != undefined &&
          Object.keys(node[Object.keys(node)[0]]?.NO).length > 0
        ) {
          traverseTree(node[Object.keys(node)[0]]?.NO, id);
        }
      }
    }
    traverseTree(obj, id);
    return [valueX, valueY, curNode];
  }

  const handleJsonSave = () => {
    setIsEditing(false);
    if (!isEditing) {
      setIsEditing(true);
    } else {
      if (validateJson()) {
        setShow(!show);
        setIsEditing(false);
        saveJson();
        // setIsShow(false);
      } else setIsShow(true);

    }
    // saveJson();

  };

  const validateJson = () => {
    var isTrueJson = true;
    function traverseTree(node) {
      if (node == null || Object.keys(node).length === 0) {
        return null;
      }
      let incomingId = node[Object?.keys(node)[0]]?.ID;
      let isValid = node["TYPE"] === "END" || node["TYPE"] === "REPEAT";
      if (
        Object.keys(node[Object.keys(node)[0]]?.YES).length === 0 &&
        !isValid
      ) {
        isTrueJson = false;
        return false;
      } else if (
        Object.keys(node[Object.keys(node)[0]]?.NO).length === 0 &&
        !isValid &&
        node["TYPE"] === "CONDITION"
      ) {
        isTrueJson = false;
        return false;
      } else {
        traverseTree(node[Object.keys(node)[0]]?.YES, incomingId);
        if (
          node[Object.keys(node)[0]]?.NO != undefined &&
          Object.keys(node[Object.keys(node)[0]]?.NO).length > 0
        ) {
          traverseTree(node[Object.keys(node)[0]]?.NO, incomingId);
        }
      }
    }
    traverseTree(buildJSON, "1");
    return isTrueJson;
  };

  const LeftPanel = (props) => {
    const handleTags = () => {
      props.setExpandedR(true);
      props.setCurSelection("tags");
    };

    const handleExitPosition = () => {
      props.setExpandedR(true);
      props.setCurSelection("close-position");
    };

    const handleRepeat = () => {
      props.setExpandedR(true);
      props.setCurSelection("repeat");
    };

    const handleEnd = () => {
      props.setExpandedR(true);
      props.setCurSelection("end");
    };
    return (
      <div className="createStrategies-leftBar pb-3">
        {/* <p className="action d-flex align-items-center justify-content-between">
          Actions Panel
        </p> */}
        {expandedL && <Row>
          <Col sm={8}>
            <p className="action d-flex align-items-center justify-content-between">
              Actions Panel
            </p>
          </Col>
          <Col sm={4}>
            <button class="btn- bt-white right"
              onClick={() => setExpandedL(!expandedL)}
              style={{
                float: "right",
                padding: "15px 3px"
              }}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
          </Col>
        </Row>}
        <div className="action-panel">
          <style>
            {`
              .action-panel .strategy-accordion {
                transition: all 0.3s ease !important;
                cursor: pointer !important;
                border-radius: 6px !important;
                padding: 8px 12px !important;
                margin: 2px 0 !important;
                border: 1px solid transparent !important;
              }
              .action-panel .strategy-accordion:hover {
                background-color: #4DD5B8 !important;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
                border: 1px solid #4DD5B8 !important;
                color: #fff !important;
              }
              .action-panel .strategy-accordion:active {
                box-shadow: 0 1px 4px rgba(0,0,0,0.1) !important;
              }
            `}
          </style>
          <div className="single">
            <div className="it d-flex strategy-accordion justify-content-between align-items-center" data-bs-toggle="collapse"
              data-bs-target="#collapse-Decision"
              aria-expanded="false"
              aria-controls="collapse-Decision">
              Decision
              <button
                className="btn btn-link p-0 text-decoration-none b-none"
                type="button"
              >
                <LiaAngleDownSolid />
              </button>
            </div>
            <div className={`collapse`} id="collapse-Decision">
              <DecisionV1
                setExpandedL={setExpandedL}
                handleClose={props.handleClose}
                clickStr={props.clickStr}
                type="decision"
                buildJSON={props.buildJSON}
                setBuildJSON={props.setBuildJSON}
                iterateCnt={props.iterateCnt}
                setIterateCnt={props.setIterateCnt}
                parentNode={props.parentNode}
                setParentNode={props.setParentNode}
                nodeKey={props.nodeKey}
                conditionCount={props.conditionCount}
                setConditionCount={props.setConditionCount}
                id={props.id}
                setId={props.setId}
                openPositions={props.openPositions}
                decitionContent={decitionContent}
                setDecitionContent={setDecitionContent}
                tagNames={tagNames}
              />
            </div>
          </div>

          <div className="single">
            <div
              className="strategy-accordion it d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-OpenPosition"
              aria-expanded="false"
              aria-controls="collapse-OpenPosition"
            >
              Open Positions
              <button
                className="btn b-none btn-link p-0 text-decoration-none"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapse-OpenPosition"
                aria-expanded="false"
                aria-controls="collapse-OpenPosition"
              >
                <LiaAngleDownSolid />
              </button>
            </div>
            <div className={`collapse`} id="collapse-OpenPosition">
              <OpenDecision
                expandedR={expandedR}
                setExpandedR={setExpandedR}
                setExpandedL={setExpandedL}
                handleClose={props.handleClose}
                clickStr={props.clickStr}
                type="open-position"
                buildJSON={props.buildJSON}
                setBuildJSON={props.setBuildJSON}
                iterateCnt={props.iterateCnt}
                setIterateCnt={props.setIterateCnt}
                parentNode={props.parentNode}
                setParentNode={props.setParentNode}
                nodeKey={props.nodeKey}
                id={props.id}
                entryCnt={props.entryCnt}
                setEntryCnt={props.setEntryCnt}
                openPositions={props.openPositions}
                setOpenPositions={props.setOpenPositions}
                curSelection={curSelection}
                setCurSelection={setCurSelection}
              />
            </div>
          </div>

          <div className="single">
            <div
              className="strategy-accordion it d-flex justify-content-between align-items-center"
              onClick={handleExitPosition}
            >
              Close Positions
            </div>
          </div>

          <div className="single">
            <div
              className="strategy-accordion it d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-AdjustPosition"
              aria-expanded="false"
              aria-controls="collapse-AdjustPosition"
            >
              Adjust Positions
              <button
                className="btn btn-link b-none p-0 text-decoration-none"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapse-AdjustPosition"
                aria-expanded="false"
                aria-controls="collapse-AdjustPosition"
              >
                <LiaAngleDownSolid />
              </button>
            </div>
            <div className={`collapse`} id="collapse-AdjustPosition">
              <UpdatePosition
                expandedR={expandedR}
                setExpandedR={setExpandedR}
                setExpandedL={setExpandedL}
                handleClose={props.handleClose}
                clickStr={props.clickStr}
                type="exist-position"
                buildJSON={props.buildJSON}
                setBuildJSON={props.setBuildJSON}
                iterateCnt={props.iterateCnt}
                setIterateCnt={props.setIterateCnt}
                parentNode={props.parentNode}
                setParentNode={props.setParentNode}
                nodeKey={props.nodeKey}
                id={props.id}
                updateCnt={props.updateCnt}
                setUpdateCnt={props.setUpdateCnt}
                openPositions={props.openPositions}
                curSelection={curSelection}
                setCurSelection={setCurSelection}
              />
            </div>
          </div>

          {/*<div className="single">
            <div
              className="strategy-accordion it d-flex justify-content-between align-items-center"
              onClick={handleTags}
            >
              Tags1
            </div>
          </div>*/}

          <div className="single">
            <div
              className="strategy-accordion it d-flex justify-content-between align-items-center"
              onClick={handleRepeat}
            >
              Repeat
            </div>
          </div>

          <div className="single">
            <div
              className="strategy-accordion it d-flex justify-content-between align-items-center"
              onClick={handleEnd}
            >
              End
            </div>
          </div>
        </div>

      </div>
    );
  };

  const RightPanel = (props) => {
    return (
      <>
        <p className="action">Properties</p>
        {curSelection === "open-position" && (
          <Col sm={12}>
            <PositionItems
              clickStr={props.clickStr}
              type="open-position"
              buildJSON={props.buildJSON}
              setBuildJSON={props.setBuildJSON}
              iterateCnt={props.iterateCnt}
              setIterateCnt={props.setIterateCnt}
              parentNode={props.parentNode}
              setParentNode={props.setParentNode}
              closeModal={props.handleClose}
              nodeKey={props.nodeKey}
              entryCnt={props.entryCnt}
              setEntryCnt={props.setEntryCnt}
              id={props.id}
              setId={props.setId}
              openPositions={props.openPositions}
              setOpenPositions={props.setOpenPositions}
              expandedR={props.expandedR}
              expandedL={props.expandedL}
              setExpandedL={props.setExpandedL}
              setExpandedR={props.setExpandedR}
              isUpdateJson={isUpdateJson}
              setCurSelection={setCurSelection}
              setIsUpdateJson={setIsUpdateJson}
            />
          </Col>
        )}

        {curSelection === "close-position" && (
          <Col sm={12}>
            <ClosePosition
              handleClose={props.handleClose}
              clickStr={props.clickStr}
              type="close-position"
              buildJSON={props.buildJSON}
              setBuildJSON={props.setBuildJSON}
              iterateCnt={props.iterateCnt}
              setIterateCnt={props.setIterateCnt}
              parentNode={props.parentNode}
              setParentNode={props.setParentNode}
              nodeKey={props.nodeKey}
              id={props.id}
              closeCnt={props.closeCnt}
              setCloseCnt={props.setCloseCnt}
              openPositions={props.openPositions}
              setOpenPositions={props.setOpenPositions}
              expandedR={props.expandedR}
              expandedL={props.expandedL}
              setExpandedL={props.setExpandedL}
              setExpandedR={props.setExpandedR}
              isUpdateJson={isUpdateJson}
              setIsUpdateJson={setIsUpdateJson}
            />
          </Col>
        )}

        {curSelection === "update-position" && (
          <Col sm={12}>
            <UpdateInputs
              clickStr={props.clickStr}
              type="exist-position"
              isUpdateJson={isUpdateJson}
              setIsUpdateJson={setIsUpdateJson}
              updateCnt={props.updateCnt}
              setUpdateCnt={props.setUpdateCnt}
              parentNode={parentNode}
              setParentNode={setParentNode}
              iterateCnt={props.iterateCnt}
              buildJSON={props.buildJSON}
              setBuildJSON={props.setBuildJSON}
              id={props.id}
              expandedR={props.expandedR}
              expandedL={props.expandedL}
              setExpandedL={props.setExpandedL}
              setExpandedR={props.setExpandedR}
            />
          </Col>
        )}

        {curSelection === "tags" && (
          <Col sm={12}>
            <Tags
              expandedR={expandedR}
              setExpandedR={setExpandedR}
              setExpandedL={setExpandedL}
              clickStr={props.clickStr}
              type="tags"
              buildJSON={props.buildJSON}
              setBuildJSON={props.setBuildJSON}
              iterateCnt={props.iterateCnt}
              setIterateCnt={props.setIterateCnt}
              parentNode={props.parentNode}
              setParentNode={props.setParentNode}
              nodeKey={props.nodeKey}
              conditionCount={props.conditionCount}
              id={props.id}
              isUpdateJson={isUpdateJson}
              setIsUpdateJson={setIsUpdateJson}
              tagsCnt={props.tagsCnt}
              setTagsCnt={props.setTagsCnt}
              tagNames={tagNames}
              setCurSelection={setCurSelection}
              setTagNames={setTagNames}
            />
          </Col>
        )}
        {curSelection === "repeat" && (
          <Col sm={12}>
            <Repeat
              expandedR={expandedR}
              setExpandedR={setExpandedR}
              setExpandedL={setExpandedL}
              clickStr={props.clickStr}
              type="repeat"
              buildJSON={props.buildJSON}
              setBuildJSON={props.setBuildJSON}
              iterateCnt={props.iterateCnt}
              setIterateCnt={props.setIterateCnt}
              parentNode={props.parentNode}
              setParentNode={props.setParentNode}
              nodeKey={props.nodeKey}
              conditionCount={props.conditionCount}
              id={props.id}
              isUpdateJson={isUpdateJson}
              setIsUpdateJson={setIsUpdateJson}
              repeatCnt={props.repeatCnt}
              setRepeatCnt={props.setRepeatCnt}
            />
          </Col>
        )}
        {curSelection === "end" && (
          <Col sm={12}>
            <EndNode
              expandedR={expandedR}
              setExpandedR={setExpandedR}
              setExpandedL={setExpandedL}
              clickStr={props.clickStr}
              type="end"
              buildJSON={props.buildJSON}
              setBuildJSON={props.setBuildJSON}
              iterateCnt={props.iterateCnt}
              setIterateCnt={props.setIterateCnt}
              parentNode={props.parentNode}
              setParentNode={props.setParentNode}
              nodeKey={props.nodeKey}
              conditionCount={props.conditionCount}
              id={props.id}
              isUpdateJson={isUpdateJson}
              setIsUpdateJson={setIsUpdateJson}
            />
          </Col>
        )}
      </>
    );
  };

  const convertToVerticalView = () => {
    if (flowchartFlow === "H") {
      setFlowchartFlow("V");
      let chartObj = null;
      chartObj = getNodes(buildJSON);
      if (chartObj.value.length > 0) {
        // let updateVal = [...chartObj.value, ...chartJson.value];
        let updateVal = [...chartObj.value, {
          id: "0",
          sourcePosition: "bottom",
          type: "selectorNode",
          data: {
            label: "Start",
            type: "start",
          },
          position: { x: window.innerWidth / 3 - 57, y: 0 },
        }];
        chartObj.value = updateVal;
        let updateObj = [
          {
            id: "0",
            source: "0",
            target: "1",
            type: "simplebezier",
            // animated: true,
            label: "",
          },
          ...chartObj.edgeObj,
        ];
        chartObj.edgeObj = updateObj;
      } else {
        chartObj = {
          value: [
            {
              id: "0",
              sourcePosition: "bottom",
              type: "selectorNode",
              data: {
                label: "Start",
                type: "start",
              },
              position: { x: window.innerWidth / 3 - 57, y: 0 },
            },
          ],
          edgeObj: []
        }
      }
      setChartJson(chartObj);
      setUpdateCharJson(!updateCharJson)
    }
  };

  const convertToHorizontalView = () => {
    if (flowchartFlow === "V") {
      setFlowchartFlow("H");
      let chartObj = getNodesHorizontal(buildJSON);
      if (chartObj.value.length > 0) {
        let updateVal = [...chartObj.value, ...chartJson.value];
        chartObj.value = updateVal;
        let updateObj = [
          {
            id: "0",
            source: "0",
            target: "1",
            type: "simplebezier",
            // animated: true,
            label: "",
          },
          ...chartObj.edgeObj,
        ];
        chartObj.edgeObj = updateObj;
        setChartJson(chartObj);
      }
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    saveJson();
  };
  return (
    <>
      <div className="dashboard-wrap p-0">
        <div className="createStrategies">

          <div className="createStrategies-header d-flex justify-content-between">
            <Toaster setIsShow={setIsShow} isShow={isShow} />
            <QuestionModal 
              isOpen={isQuestionModalShow}
              question="Are you sure you want to leave this page? Your changes will be lost."
              onClose={handleQuestionModalClose}
            />
            <div className="header-left d-flex align-items-center">
              <Link
                to="/strategies"
                className="backBtn p-0 border-0 text-white d-flex align-items-center justify-content-center"
              >
                <LiaAngleLeftSolid />
              </Link>
              {isEditing ? <>

                <input
                  type="text"
                  className="form-control me-2"
                  value={strategyName}
                  onChange={(e) => setStrategyName(e.target.value)}
                />
                <button
                  className="btn btn-success hide"
                  onClick={handleSaveClick}
                >
                  Submit
                </button>
              </> :
                <>
                  <p className="">{strategyName}</p>

                  <button className="edit bg-primary border-0  d-flex align-items-center justify-content-center" onClick={handleEditClick}>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.75001 3.50137L10.5 5.25137M7.58334 11.668L12.25 11.668M2.91668 9.3347L2.33334 11.668L4.66668 11.0847L11.4252 4.3262C11.6439 4.10742 11.7668 3.81073 11.7668 3.50137C11.7668 3.19201 11.6439 2.89532 11.4252 2.67654L11.3248 2.5762C11.1061 2.35749 10.8094 2.23462 10.5 2.23462C10.1907 2.23462 9.89396 2.35749 9.67518 2.5762L2.91668 9.3347Z"
                        stroke="#151B22"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </>}
            </div>

            <div className="header-right d-flex gap-2 gap-xl-3 align-items-center">
              <div className="arrow-btn p-1 d-flex gap-1 d-none">
                <button
                  className={flowchartFlow === "H" ? "active" : ""}
                // onClick={convertToHorizontalView}
                >
                  <BsArrowRight />
                </button>
                <button
                  className={flowchartFlow === "V" ? "active" : ""}
                // onClick={convertToVerticalView}
                >
                  <BsArrowDown />
                </button>
              </div>
              <div className="header-right-btn d-flex gap-2 gap-xl-3">
                <button className="btn text-white padding d-none">Close</button>
                <button 
                  className="btn bg-primary padding" 
                  onClick={handleJsonSave}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Spinner size="sm" />
                      <span>Saving...</span>
                    </div>
                  ) : (
                    'Save'
                  )}
                </button>
                <button className="btn play text-primary d-flex align-items-center justify-content-center  d-none">
                  <BsPlay />
                </button>
                <button className="btn play d-flex align-items-center justify-content-center  d-none">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.64113 4.69727C7.48482 4.69727 7.33491 4.75936 7.22438 4.86989C7.11385 4.98042 7.05176 5.13033 7.05176 5.28664C7.05176 5.44295 7.11385 5.59286 7.22438 5.70339C7.33491 5.81392 7.48482 5.87602 7.64113 5.87602H12.3561C12.5124 5.87602 12.6624 5.81392 12.7729 5.70339C12.8834 5.59286 12.9455 5.44295 12.9455 5.28664C12.9455 5.13033 12.8834 4.98042 12.7729 4.86989C12.6624 4.75936 12.5124 4.69727 12.3561 4.69727H7.64113Z"
                      fill="currentColor"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.95375 1.55371C8.32472 1.55371 7.04145 1.55371 6.03873 1.68966C5.00929 1.82954 4.18809 2.12344 3.54292 2.77568C2.89854 3.42714 2.60935 4.25462 2.47105 5.29192C2.33667 6.30486 2.33667 7.6007 2.33667 9.24781V13.254C2.33667 14.439 2.33667 15.3765 2.41211 16.083C2.48676 16.7808 2.64629 17.4103 3.10364 17.8315C3.46984 18.1694 3.93348 18.3815 4.42856 18.4389C5.04701 18.5096 5.6246 18.2142 6.19433 17.8102C6.77034 17.4032 7.46895 16.7847 8.35065 16.0052L8.37894 15.98C8.78758 15.6186 9.06419 15.3749 9.29522 15.2052C9.5184 15.0425 9.65435 14.9836 9.76908 14.96C9.9206 14.9302 10.0765 14.9302 10.228 14.96C10.3427 14.9836 10.4795 15.0425 10.7019 15.2052C10.9329 15.3742 11.2095 15.6186 11.6181 15.98L11.6472 16.0052C12.5281 16.7847 13.2267 17.4032 13.8028 17.811C14.3725 18.2142 14.9501 18.5096 15.5685 18.4389C16.0634 18.382 16.5274 18.1693 16.8934 17.8315C17.35 17.4103 17.5103 16.7808 17.585 16.083C17.6604 15.3765 17.6604 14.439 17.6604 13.254V9.24781C17.6604 7.6007 17.6604 6.30407 17.526 5.29192C17.3877 4.25462 17.0985 3.42714 16.4542 2.77568C15.809 2.12344 14.9878 1.82954 13.9584 1.68966C12.9556 1.55371 11.6724 1.55371 10.0433 1.55371H9.95375ZM4.37984 3.60474C4.7704 3.21025 5.30083 2.98 6.19668 2.85819C7.11061 2.73403 8.31372 2.73246 9.99776 2.73246C11.6818 2.73246 12.8849 2.73403 13.7988 2.85819C14.6947 2.98 15.2251 3.21025 15.6157 3.60474C16.007 4.00001 16.2357 4.53831 16.3567 5.44752C16.4793 6.37323 16.4809 7.59048 16.4809 9.2926V13.2163C16.4809 14.4469 16.4801 15.3223 16.4125 15.9573C16.3418 16.6095 16.2137 16.8539 16.0943 16.9647C15.9104 17.1336 15.6793 17.2397 15.4342 17.2672C15.277 17.2853 15.0145 17.2248 14.4833 16.8492C13.9662 16.4822 13.3148 15.9077 12.3985 15.0968L12.378 15.0787C11.9946 14.74 11.6771 14.4595 11.3965 14.2536C11.1034 14.0398 10.808 13.8748 10.4598 13.8049C10.1548 13.7434 9.84068 13.7434 9.53569 13.8049C9.18756 13.8756 8.89131 14.0398 8.59898 14.2544C8.31843 14.4587 8.00096 14.74 7.61747 15.0787L7.59704 15.0968C6.68076 15.9077 6.0293 16.4822 5.51222 16.8492C4.981 17.2248 4.71853 17.2853 4.56136 17.2672C4.31481 17.2389 4.08365 17.133 3.90126 16.9647C3.78182 16.8539 3.65294 16.6095 3.58379 15.9573C3.51542 15.3215 3.51463 14.4469 3.51463 13.2163V9.29181C3.51463 7.59048 3.51621 6.37323 3.6388 5.44752C3.75981 4.53831 3.98849 4.00001 4.37984 3.60474Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>

          </div>
          <div className="createStrategies-wrap d-flex" style={{ position: "relative" }}>
            <>
              {/* {!expandedL && <button class="bt-white flowchart-sidebar left" onClick={() => setExpandedL(!expandedL)}>
                <FontAwesomeIcon icon={faAngleRight} style={{
                  padding: "10px",
                }} />
              </button>} */}
              {expandedL && <LeftPanel
                expandedL={expandedL}
                setExpandedL={setExpandedL}
                id={id}
                setId={setId}
                setCurSelection={setCurSelection}
                expandedR={expandedR}
                setExpandedR={setExpandedR}
                clickStr={clickStr}
                buildJSON={buildJSON}
                setBuildJSON={setBuildJSON}
                iterateCnt={iterateCnt}
                setIterateCnt={setIterateCnt}
                parentNode={parentNode}
                setParentNode={setParentNode}
                entryCnt={entryCnt}
                setEntryCnt={setEntryCnt}
                openPositions={openPositions}
                setOpenPositions={setOpenPositions}
                updateCnt={updateCnt}
                setUpdateCnt={setUpdateCnt}
                conditionCount={conditionCount}
                closeCnt={closeCnt}
                setCloseCnt={setCloseCnt}
              />}
            </>
            <div
              className="createStrategies-content d-flex flex-column pb-3"
            >
              {decisionObject.showFields &&
                decisionObject.selectedObj != "" && (
                  <div className="content-header d-flex mx-auto justify-content-between">
                    <DecisionItems
                      decitionContent={decitionContent}
                      dataObj={decisionObject.selectedObj}
                      // updateObj={handleObj}
                      isOpen={decisionObject.showFields}
                      clickStr={clickStr}
                      type="decision"
                      decisionObject={decisionObject}
                      hideFields={setDecisionObject}
                      buildJSON={buildJSON}
                      setBuildJSON={setBuildJSON}
                      iterateCnt={iterateCnt}
                      setIterateCnt={setIterateCnt}
                      parentNode={parentNode}
                      setParentNode={setParentNode}
                      // closeModal={handleClose}
                      // nodeKey={nodeKey}
                      conditionCount={conditionCount}
                      setConditionCount={setConditionCount}
                      id={id}
                      setId={setId}
                      openPositions={openPositions}
                      expandedL={expandedL}
                      setExpandedL={setExpandedL}
                      isUpdateJson={isUpdateJson}
                      setIsUpdateJson={setIsUpdateJson}
                      tagNames={tagNames}
                    />
                  </div>
                )}


              {Object.keys(chartJson).length > 0 &&
                isChart && (
                  < ReactFlowProvider >
                    <Flowchart
                      strategy_id={window.location.search.split("=")[1]}
                      data={buildJSON}
                      setBuildJSON={setBuildJSON}
                      isUpdateJson={isUpdateJson}
                      setIsUpdateJson={setIsUpdateJson}
                      chartObj={chartJson}
                      setJsonKey={setJsonKey}
                      setSelectedItem={setSelectedItem}
                      handleOpenModal={handleOpenModal}
                      setClickStr={setClickStr}
                      setShowModal={setShowModal}
                      nodeNo={nodeNo}
                      setNodeNo={setNodeNo}
                      updateNodes={updateNodes}
                      setUpdateNodes={setUpdateNodes}
                      setParentNode={setParentNode}
                      expandedL={expandedL}
                      setExpandedL={setExpandedL}
                      id={id}
                      setId={setId}
                    />

                  </ReactFlowProvider>
                )}
              {!isChart && <ChartLoader />}


            </div>

            {expandedR && <div className="createStrategies-leftBar rightBar">
              <RightPanel
                expandedL={expandedL}
                setExpandedL={setExpandedL}
                expandedR={expandedR}
                setExpandedR={setExpandedR}
                id={id}
                setId={setId}
                clickStr={clickStr}
                buildJSON={buildJSON}
                setBuildJSON={setBuildJSON}
                iterateCnt={iterateCnt}
                setIterateCnt={setIterateCnt}
                parentNode={parentNode}
                setParentNode={setParentNode}
                entryCnt={entryCnt}
                setEntryCnt={setEntryCnt}
                openPositions={openPositions}
                setOpenPositions={setOpenPositions}
                updateCnt={updateCnt}
                setUpdateCnt={setUpdateCnt}
                conditionCount={conditionCount}
                repeatCnt={repeatCnt}
                setRepeatCnt={setRepeatCnt}
                tagsCnt={tagsCnt}
                setTagsCnt={setTagsCnt}
                tagNames={tagNames}
                setTagNames={setTagNames}
                closeCnt={closeCnt}
                setCloseCnt={setCloseCnt}
              />
            </div>}


          </div>
        </div>
      </div >


    </>
  );
}

export default Strategy;
